/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { UnsplashTracker } from '@trello/unsplash';
import { FavIcon } from 'app/scripts/lib/favicon';
import { Backgrounds } from 'app/scripts/data/backgrounds';
import { Util } from 'app/scripts/lib/util';

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null
    ? transform(value)
    : undefined;
}

export const getAllBackgroundClasses = () =>
  [
    'body-custom-board-background',
    'body-custom-board-background-tiled',
    'body-light-board-background',
    'body-dark-board-background',
    'body-default-header',
  ].join(' ');

export const defaultBoardBackground = function () {
  this.clearBoardBackground();
  $('#trello-root').addClass('body-default-header');
};

export const clearBoardBackground = function () {
  const allBackgroundClasses = this.getAllBackgroundClasses();

  $('#trello-root').removeClass(allBackgroundClasses).css({
    'background-image': '',
    'background-color': '',
  });
};

export const renderBoardBackground = function (waitForImage) {
  if (waitForImage == null) {
    waitForImage = false;
  }
  this.clearBoardBackground();

  const prefs = this.model.get('prefs');
  // eslint-disable-next-line @trello/enforce-variable-case
  const $body = $('#trello-root');

  if (prefs.background.startsWith('gradient-')) {
    const gradientUrl = prefs.backgroundImage;

    const changeBackgroundImage = () => {
      $body.addClass('body-gradient-board-background');

      $body.css({
        'background-color': prefs.backgroundColor,
        'background-image': `url("${gradientUrl}")`,
      });

      return FavIcon.setBackground({
        color: prefs.backgroundColor,
        topColor: prefs.backgroundTopColor,
        bottomColor: prefs.backgroundBottomColor,
      });
    };
    return changeBackgroundImage();
  }

  if (prefs.backgroundColor != null) {
    const hexcolor = this.model.getClientBackgroundColor(prefs.background);

    $body.css({
      'background-color': hexcolor,
    });

    return FavIcon.setBackground({ color: hexcolor });
  } else {
    let smallUrl, url;
    if (Object.prototype.hasOwnProperty.call(Backgrounds, prefs.background)) {
      // Special handling for our default backgrounds, to avoid using the
      // really huge versions
      let left;
      url =
        (left = __guard__(
          Util.smallestPreviewBiggerThan(prefs.backgroundImageScaled, 640, 480),
          (x) => x.url,
        )) != null
          ? left
          : prefs.backgroundImage;
    } else {
      let left1;
      url =
        (left1 = __guard__(
          Util.biggestPreview(
            prefs.backgroundImageScaled,
            prefs.backgroundImage,
          ),
          (x1) => x1.url,
        )) != null
          ? left1
          : prefs.backgroundImage;
    }

    if (prefs.backgroundTile) {
      smallUrl = url;
    } else {
      let left2;
      smallUrl =
        (left2 = __guard__(
          Util.smallestPreviewBiggerThan(prefs.backgroundImageScaled, 64, 64),
          (x2) => x2.url,
        )) != null
          ? left2
          : prefs.backgroundImage;
    }

    const changeBackgroundImage = () => {
      $body.addClass('body-custom-board-background');

      if (prefs.backgroundTile) {
        $body.addClass('body-custom-board-background-tiled');
      }

      const brightness = prefs.backgroundBrightness;

      switch (brightness) {
        case 'light':
          $body.addClass('body-light-board-background');
          break;
        case 'dark':
          $body.addClass('body-dark-board-background');
          break;
        default:
      }

      $body.css({
        'background-image': `url("${url}")`,
      });

      UnsplashTracker.trackOncePerInterval(url);

      return FavIcon.setBackground({
        url: smallUrl,
        tiled: prefs.backgroundTile,
      });
    };

    if (waitForImage) {
      return Util.waitForImageLoad(url).then(changeBackgroundImage);
    } else {
      return changeBackgroundImage();
    }
  }
};

export const renderBoardHeaderSubscribed = function () {
  const isSubscribed = this.model.get('subscribed');
  $('.js-board-header-subscribed', this.$el).toggleClass('hide', !isSubscribed);
  return this;
};
